import { QueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import api from "./axios";

const handleError = (err) => {
  let errorMessage = "Something went wrong";

  if (err?.isAxiosError) {
    if (err?.response && err?.response?.data && err?.response?.data?.message) {
      errorMessage = err?.response?.data?.message;
    } else {
      errorMessage = err?.message;
    }
  }

  console.error("Error:", err);
  if (errorMessage === "jwt expired") {
    //TODO: add logout function
  } else {
    toast.error(errorMessage);
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {},
    queries: {
      queryFn: async (keys) => {
        const token = localStorage.getItem("userToken");
        const jsonToken = JSON.parse(token);
        let headers = {};
        if (token) {
          headers["Authorization"] = `Bearer ${jsonToken}`;
        }

        const { data } = await api.get(keys.queryKey[0], {
          headers,
        });

        if (data?.ok === false) {
          throw new Error(data?.message || "Something went wrong");
        }

        return data;
      },
      onError: handleError,
      retry: 3,
    },
  },
});
